import React, { useState } from 'react';
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { ArrowLeft, ArrowRight } from 'lucide-react';

const AutoplayPlugin = (slider) => {
    let timeout;
    let mouseOver = false;

    function clearNextTimeout() {
        clearTimeout(timeout);
    }

    function nextTimeout() {
        clearTimeout(timeout);
        if (mouseOver) return;
        timeout = setTimeout(() => {
            slider.next();
        }, 3000); // 3000ms = 3 seconds delay per slide
    }

    slider.on("created", () => {
        slider.container.addEventListener("mouseover", () => {
            mouseOver = true;
            clearNextTimeout();
        });
        slider.container.addEventListener("mouseout", () => {
            mouseOver = false;
            nextTimeout();
        });
        nextTimeout();
    });
    slider.on("dragStarted", clearNextTimeout);
    slider.on("animationEnded", nextTimeout);
    slider.on("updated", nextTimeout);
};

const ProcessSection = ({ data }) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        loop: true,
        slides: {
            origin: "center",
            perView: 1.5,
            spacing: 20,
        },
        breakpoints: {
            "(min-width: 768px)": {
                slides: { origin: "center", perView: 2.5, spacing: 30 },
            },
            "(min-width: 1024px)": {
                slides: { origin: "center", perView: 3, spacing: 40 },
            },
        },
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
    }, [AutoplayPlugin]);

    // Agar data nahi hai to render mat karo
    if (!data) return null;

    return (
        <section className="w-full pb-16 lg:pb-24 overflow-hidden flex flex-col items-center">

            {/* Dynamic Heading */}
            <h2 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora mb-16">
                {data.heading}
            </h2>

            <div className="w-full max-w-[1440px] px-0 lg:px-[40px] relative">
                <div ref={sliderRef} className="keen-slider !overflow-visible flex items-center h-[350px]">
                    {/* Dynamic Process Steps */}
                    {data.steps.map((step, idx) => {
                        const isActive = currentSlide === idx;

                        return (
                            <div key={idx} className="keen-slider__slide flex items-center justify-center h-full">
                                <div className={`
                                    w-full bg-white flex flex-col transition-all duration-500 ease-out border border-[#BAC9D7]
                                    ${isActive
                                        ? 'h-[280px] p-8 shadow-[0_10px_30px_rgba(0,0,0,0.05)] border-b-4 border-b-[#ED6800] scale-100 z-10'
                                        : 'h-[180px] p-6 shadow-sm scale-[0.9] opacity-70 justify-center items-center text-center'}
                                `}>

                                    {isActive ? (
                                        <>
                                            <div className="flex justify-between items-start mb-6">
                                                <h3 className="text-[#01386A] lg:text-[20px] text-[16px] font-[600] font-sora w-[70%]">
                                                    {step.title}
                                                </h3>
                                                <span className="text-[#ED6800] lg:text-[20px] text-[16px] font-[600] font-sora">
                                                    {step.id}
                                                </span>
                                            </div>
                                            <p className="text-[#49577A] lg:text-[16px] text-[14px] font-[500] font-graphik leading-[24px] mt-auto">
                                                {step.desc}
                                            </p>
                                        </>
                                    ) : (
                                        <h3 className="text-[#49577A] lg:text-[20px] text-[16px] font-[600] font-sora">
                                            {step.title}
                                        </h3>
                                    )}

                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="flex justify-center items-center gap-4 mt-[20px]">
                    <button
                        onClick={() => instanceRef.current?.prev()}
                        className="w-[40px] h-[40px] rounded-full border border-[#ED6800] text-[#ED6800] flex items-center justify-center hover:bg-[#ED6800] hover:text-white transition-colors duration-300"
                    >
                        <ArrowLeft size={18} />
                    </button>

                    <button
                        onClick={() => instanceRef.current?.next()}
                        className="w-[40px] h-[40px] rounded-full border border-[#ED6800] text-[#ED6800] flex items-center justify-center hover:bg-[#ED6800] hover:text-white transition-colors duration-300"
                    >
                        <ArrowRight size={18} />
                    </button>
                </div>
            </div>

        </section>
    );
};

export default ProcessSection;